/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from "axios";
import { AppDispatch } from "../app/store";
import { tokenGeldi } from "../features/currentUserSlice";
import { AuthenticationResponseViewModel } from "../models/viewModels/AuthenticationResponseViewModel";
import LocalStorageHelper from "./LocalStorageHelper";

// Token'ın geçerlilik süresi token'ın kendisinden (JWT `exp` claim) okunur; ayrı bir
// expiry state tutulmaz. Böylece token tek doğruluk kaynağıdır (drift olmaz) ve daha
// önce login olmuş, localStorage'ında expiry kaydı olmayan kullanıcılar için de çalışır.

// Kalan süre bu eşiğin altına düştüğünde token proaktif olarak yenilenir.
export const RENEW_THRESHOLD_MS = 2 * 24 * 60 * 60 * 1000; // 2 gün

// Renew kontrolünün ne sıklıkla tekrarlanacağı (uygulama uzun süre açık kalırsa).
export const RENEW_INTERVAL_MS = 6 * 60 * 60 * 1000; // 6 saat

function base64UrlDecode(input: string): string {
    let base64 = input.replace(/-/g, "+").replace(/_/g, "/");
    const pad = base64.length % 4;
    if (pad) base64 += "=".repeat(4 - pad);
    const binary = atob(base64);
    const bytes = Uint8Array.from(binary, c => c.charCodeAt(0));
    return new TextDecoder().decode(bytes);
}

// JWT `exp` claim'ini (epoch saniye) milisaniyeye çevirip döner. Okunamazsa null.
export function getTokenExpiryMs(token: string): number | null {
    try {
        const parts = token.split(".");
        if (parts.length < 2) return null;
        const payload = JSON.parse(base64UrlDecode(parts[1]));
        if (typeof payload.exp !== "number") return null;
        return payload.exp * 1000;
    } catch {
        return null;
    }
}

// localStorage'daki token'ı, süresi eşiğin altına düşmüşse yeni 7 günlük token'la değiştirir.
// Başarılıysa hem localStorage hem Redux güncellenir; AxiosProvider interceptor'ı bir sonraki
// istekte yeni token'ı otomatik kullanır. Hata olursa sessizce geçilir (gerçek bir istek 401
// alırsa mevcut akış zaten login'e yönlendirir).
export async function renewTokenIfNeeded(dispatch: AppDispatch, thresholdMs: number = RENEW_THRESHOLD_MS): Promise<void> {
    const token = LocalStorageHelper.getToken();
    if (!token)
        return;

    const expiryMs = getTokenExpiryMs(token);
    if (expiryMs != null) {
        const remaining = expiryMs - Date.now();
        if (remaining > thresholdMs)
            return; // yenilemek için henüz erken
        if (remaining <= 0)
            return; // token zaten expired; renew 401 olur, bir sonraki gerçek istek login'e atar
    }

    try {
        const response = await axios.post<AuthenticationResponseViewModel>("api/kullanici/renew", null);
        const newToken = response.data?.token;
        if (newToken) {
            LocalStorageHelper.setToken(newToken);
            dispatch(tokenGeldi({ token: newToken }));
        }
    } catch {
        // sessizce geç
    }
}
